export default {"src":"/_next/static/media/review-source-booking-com.bd4da1db.svg","height":19,"width":80};